import { getPickupsInGroup, isGroupHeaders } from '../Pickups/GroupPickup/utils';
const getPickupIdList = (assignPickupDetails) => {
  return assignPickupDetails.flatMap((pickup) => pickup.pickupIds?.map((id) => id?.toUpperCase()) || []);
};

const checkIfGroupedPickupsInSelection = (pickupDetails, DispatchStore) => {
  const allPickups = DispatchStore?.pickupsList?.slice() ?? [];
  const pickupIds = pickupDetails.flatMap((pickup) =>
    Array.isArray(pickup.pickupId)
      ? pickup.pickupId.map((id) => id.toUpperCase())
      : [pickup.pickupId?.toUpperCase()]
  );
  const selectedPickupIds = new Set(pickupIds);

  // Create a map of groupId to total count and selected count
  const groupStats = {};
  
  allPickups.forEach((pickup) => {
    if(isGroupHeaders(pickup)) {
      // skip group header as it is not a pickup row
      return;
    }
    const { groupId, pickupId } = pickup;
    
    if (!groupStats[groupId]) {
      groupStats[groupId] = { total: 0, selected: 0 };
    }
    
    groupStats[groupId].total++;
    
    if (selectedPickupIds.has(pickupId)) {
      groupStats[groupId].selected++;
    }
  });

  // Check if any group has partial selection (some but not all pickups selected)
  return Object.values(groupStats).some(({ total, selected }) => selected > 0 && selected < total);
};

const getPickupDetailsWithAllGroupedPickups = (pickupDetails, DispatchStore) => {
  const allPickups = DispatchStore?.pickupsList?.slice() ?? [];
  const groupedPickupDetails = pickupDetails?.map((pickup) => {
    const pickupsInGroup = getPickupsInGroup(pickup.groupId, allPickups);
    const { pickupId, ...rest } = pickup;
    const fallbackPickupIds = Array.isArray(pickupId) ? pickupId : [pickupId];
    const pickupIds = pickupsInGroup.length
      ? pickupsInGroup.map((groupPickup) => groupPickup.pickupId)
      : fallbackPickupIds.filter(Boolean);
    return {
      ...rest,
      pickupIds,
    };
  });
  return groupedPickupDetails;
};
export { getPickupIdList, checkIfGroupedPickupsInSelection, getPickupDetailsWithAllGroupedPickups };